import * as config from './modules/config';
import { validateConfig } from '../config/validate';
import { createPortalRuntimeContext } from './initialization/runtimeContext';
import { registerStaticHandlers } from './initialization/registerStaticHandlers';
import { createBootSequence, attachBootSequence } from './initialization/bootSequence';
import { createLogger } from '../shared/logger';

const log = createLogger('portal:bootstrap');

validateConfig();

(async function bootstrapPortalApp() {
  const cfg = await config.loadConfig();
  if (!cfg) {
    log.warn('[bootstrap] No config available; aborting startup');
    return;
  }

  const context = createPortalRuntimeContext(cfg);
  registerStaticHandlers(context);

  const boot = createBootSequence(context);
  attachBootSequence(boot);
})().catch(err => {
  log.error('[bootstrap] Bootstrap failed:', err);
});
